/**
 * How a trader is named in every "pick a trader" box.
 *
 * "Simon Wang — Supply Trader": the person's name, then their job title from
 * their staff record. The title is their job at HMS, not their role on the
 * deal, so a Supply Trader can still be picked as a deal's Customer Trader.
 *
 * Before this rule each box wrote its own label (ledger row 133): the bunkers
 * enquiry's Customer Trader box added the title, while its Supplier Trader box
 * and the three bunkers recap boxes printed the name alone, although all five
 * read the same list and the server sends the title with every trader
 * (employees/hms_views.py, hms_employees_list).
 */
export function traderLabel(trader) {
  if (!trader) return '';
  const name = [
    trader.display_name,
    `${trader.first_name || ''} ${trader.last_name || ''}`,
    trader.email,
  ].map((part) => (part || '').trim()).find(Boolean) || '';
  const title = (trader.position?.name || '').trim();
  return title ? `${name} — ${title}` : name;
}

export default traderLabel;
